import { render } from "./PackageSection.vue?vue&type=template&id=3df55703&scoped=true"
import script from "./PackageSection.vue?vue&type=script&lang=js"
export * from "./PackageSection.vue?vue&type=script&lang=js"

import "./PackageSection.vue?vue&type=style&index=0&id=3df55703&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df55703"]])

export default __exports__